import { OrganizationKeyName } from "../../../model/Organization";

export const UPSERT_VOUCHER_POPUP_VISIBLE_ACTION =
  "USER:UPSERT_VOUCHER_VISIBLE_ACTION";

export const upsertVoucherPopupVisibleAction = (
  organization: OrganizationKeyName,
  isVisible: boolean,
  id: string
) => ({
  type: UPSERT_VOUCHER_POPUP_VISIBLE_ACTION as typeof UPSERT_VOUCHER_POPUP_VISIBLE_ACTION,
  isVisible,
  id,
});

export type UpsertVoucherPopupVisibleAction = ReturnType<
  typeof upsertVoucherPopupVisibleAction
>;
